package org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.reports_table.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.flow.emptyFlow
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.rippleEffect
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.PeriodDaysEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.formatDate
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.FilterComponent
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.reports_table.component.days_filter_dialog.ClosingReportsDaysFilterDialog
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.reports_table.component.calendar_filter_dialog.ClosingReportsCalendarDialog
import org.jetbrains.compose.web.css.LineStyle


@Composable
fun ReportsTableFilterOptions(
    windowSizeMode: WindowSizeModeEnum,
    selectedPeriodType: PeriodDaysEnum?,
    showDaysFilterDialog: Boolean,
    showFromCalendarFilterDialog:Boolean,
    showToCalendarFilterDialog:Boolean,
    selectedFrom:String,
    selectedCalendarHeaderYear:Int,
    selectedTo:String,
    selectedDateFrom:MonthModel?,
    selectedDateTo:MonthModel?,
    setDaysFilterDialogStatus: (Boolean) -> Unit,
    setFromCalendarFilterDialogStatus:(Boolean)->Unit,
    setToCalendarFilterDialogStatus:(Boolean)->Unit,
    submitFilterItemsBasedOnDays:(String, String, PeriodDaysEnum)->Unit,
    onSelectFromDate:(MonthModel)->Unit,
    onSelectToDate:(MonthModel)->Unit,
    filterDate:(String,String)->Unit,
    closeFromCalendarDialog:()->Unit,
    closeToCalendarDialog:()->Unit,
    setNewCalendarHeaderYear:(Int)->Unit,
) {
    Column(
        modifier = Modifier
            .margin(bottom = Dimen.normalPadding)
            .fillMaxWidth()
        ,
    )
    {
        Column(
            modifier = Modifier
                .fillMaxWidth(),
        )
        {
            FilterComponent(
                title = Strings.current().filter,
                onFilterClick = {
                    setDaysFilterDialogStatus(!showDaysFilterDialog)
                },
            )

            DateFilterComponent(
                modifier = Modifier
                    .margin(
                        top = Dimen.extraLargePadding,
                        bottom = Dimen.mediumPadding,
                    )
                    .fillMaxWidth()
                    .weight(1f),
                windowSizeMode = windowSizeMode,
                dateStart = selectedFrom,
                dateEnd = selectedTo,
                onDateStartFilterClick = {
                    setFromCalendarFilterDialogStatus(!showFromCalendarFilterDialog)
                },
                onDateEndFilterClick = {
                    setToCalendarFilterDialogStatus(!showToCalendarFilterDialog)
                },
            )


        }

        Box(
            modifier = Modifier.fillMaxWidth()
        )
        {
            if (showDaysFilterDialog){
                ClosingReportsDaysFilterDialog(
                    modifier = Modifier.align(Alignment.CenterStart),
                    selectedPeriodType =selectedPeriodType?:PeriodDaysEnum.TODAY,
                    onCloseFilterClick = {
                        setDaysFilterDialogStatus(false)
                    },
                    submitFilterItems = {
                        submitFilterItemsBasedOnDays(
                            it.from,
                            it.to,
                            it
                        )
                    }
                )
            }

            if (showFromCalendarFilterDialog) {
                ClosingReportsCalendarDialog(
                    modifier = Modifier
                        .align(Alignment.CenterEnd),
                    selectedDate = selectedDateFrom,
                    selectedFrom =selectedFrom ,
                    selectedTo = selectedTo,
                    selectedCalendarHeaderYear =selectedCalendarHeaderYear ,
                    onSelectDate = {
                        onSelectFromDate(it)
                    },
                    filterDate = {from:String,to:String->
                        filterDate(from,to)
                    },
                    closeCalendarDialog = {
                        closeFromCalendarDialog()
                    },
                    setNewCalendarHeaderYear = {
                        setNewCalendarHeaderYear(it)
                    }
                )
            }

            if (showToCalendarFilterDialog) {
                ClosingReportsCalendarDialog(
                    modifier = Modifier
                        .align(Alignment.CenterEnd),
                    selectedDate = selectedDateTo,
                    selectedFrom =selectedFrom ,
                    selectedTo = selectedTo,
                    selectedCalendarHeaderYear =selectedCalendarHeaderYear ,
                    onSelectDate = {
                        onSelectToDate(it)
                    },
                    filterDate = {from:String,to:String->
                        filterDate(from,to)
                    },
                    closeCalendarDialog = {
                        closeToCalendarDialog()
                    },
                    setNewCalendarHeaderYear = {
                        setNewCalendarHeaderYear(it)
                    }
                )
            }
        }

    }
}



@Composable
fun DateFilterComponent(
    windowSizeMode: WindowSizeModeEnum,
    modifier: Modifier = Modifier,
    dateStart: String,
    dateEnd:String,
    onDateStartFilterClick: () -> Unit,
    onDateEndFilterClick: () -> Unit,
) {
    Row(
        modifier = modifier
            .cursor(Cursor.Pointer)
            .minHeight(Dimen.filterHeight)
            .height(Dimen.filterHeight)
            .padding(
                leftRight = Dimen.normalPadding,
            )
            .borderRadius(Dimen.lowBorderRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            ),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Start

    )
    {
        Box(
            modifier=Modifier
//                .weight(1f)
                .rippleEffect {
                    it.stopPropagation()
                    onDateStartFilterClick()
                }
                .fillMaxHeight()
                .cursor(Cursor.Pointer)
        )
        {
            SpanText(
                text = if (dateStart.isNotEmpty()) formatDate(dateStart)
                else "",
                modifier = Modifier
                    .align(Alignment.Center)
                    .cursor(Cursor.Pointer)
                    .fontSize(
                        if (windowSizeMode== WindowSizeModeEnum.PHONE)
                            FontSizes.semiMediumFontSize else
                            FontSizes.mediumFontSize
                    )
                    .color(Theme.TextPrimary.rgb)
                    .fontWeight(FontWeight.Normal)
                    .fontFamily(FontFamily.Jakarta)
            )
        }

        SpanText(
            "-",
            modifier = Modifier
                .cursor(Cursor.Pointer)
                .margin(leftRight = Dimen.smallPadding)
                .fontSize(FontSizes.mediumFontSize)
                .color(Theme.TextPrimary.rgb)
                .fontWeight(FontWeight.Normal)
                .fontFamily(FontFamily.Jakarta)
        )

        Box(
            modifier=Modifier
//                .weight(1f)
                .rippleEffect {
                    it.stopPropagation()
                    onDateEndFilterClick()
                }
                .fillMaxHeight()
                .cursor(Cursor.Pointer)
        ){
            SpanText(
                text = if (dateEnd.isNotEmpty()) formatDate(dateEnd)
                else "",
                modifier = Modifier
                    .align(Alignment.Center)
                    .cursor(Cursor.Pointer)
                    .fontSize(
                        if (windowSizeMode== WindowSizeModeEnum.PHONE)
                            FontSizes.semiMediumFontSize else
                            FontSizes.mediumFontSize
                    )
                    .color(Theme.TextPrimary.rgb)
                    .fontWeight(FontWeight.Normal)
                    .fontFamily(FontFamily.Jakarta)
            )
        }

        Spacer()


        VectorIcon(
            pathData = Res.PathIcon.calendar2,
            color = Theme.TextSecondary.hex,
            width = Dimen.normalIconSize,
            height = Dimen.normalIconSize
        )


    }
}



